var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.035 0 0 4.035 0 9C0 13.965 4.035 18 9 18C13.965 18 18 13.965 18 9C18 4.035 13.965 0 9 0ZM9 16.5C4.86 16.5 1.5 13.14 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9C16.5 13.14 13.14 16.5 9 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.645 3.825C8.205 3.465 6.6 4.38 6.165 5.79C6.03 6.195 6.255 6.615 6.645 6.735C7.035 6.855 7.455 6.645 7.59 6.24C7.8 5.58 8.61 5.115 9.3 5.28C9.975 5.445 10.485 6.24 10.35 6.93C10.23 7.62 9.495 8.175 8.79 8.085C8.58 8.055 8.355 8.13 8.205 8.265C8.04 8.415 7.95 8.61 7.95 8.835L7.935 11.175C7.935 11.595 8.265 11.925 8.685 11.925C9.105 11.925 9.435 11.595 9.435 11.175L9.45 9.54C10.605 9.315 11.625 8.37 11.835 7.185C12.105 5.73 11.1 4.185 9.645 3.825Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.715 12.585H8.7C8.295 12.585 7.965 12.93 7.95 13.335C7.95 13.35 7.95 13.485 7.95 13.5C7.95 13.905 8.28 14.175 8.685 14.19H8.7C9.105 14.19 9.435 13.815 9.45 13.41C9.45 13.395 9.45 13.305 9.45 13.29C9.435 12.885 9.12 12.585 8.715 12.585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsWhite);
export default __webpack_public_path__ + "static/media/faqs-white.45e973b2c72bb21740e87fbbac52b347.svg";
export { ForwardRef as ReactComponent };